module.exports = __webpack_public_path__ + "static/assets/img/educations_1.b95b2f73.svg";